import React from 'react'

const APPLE_WALLET_SVG =
  'https://liveonbeat.s3.us-east-1.amazonaws.com/passes/US-UK_Add_to_Apple_Wallet_RGB_101421.svg'
const GOOGLE_WALLET_SVG =
  'https://liveonbeat.s3.us-east-1.amazonaws.com/passes/enUS_add_to_google_wallet_add-wallet-badge.svg'

function Wallets({
  eventId,
  userEmail,
  text = 'Save your tickets to your phone',
  subtext = 'Tap a wallet button below to add your pass and keep it ready for entry.',
  note = 'If you do not see the wallet screen, make sure you are on your phone.',
}) {
  const badgeClassName =
    'inline-flex items-center justify-center rounded-md transition hover:-translate-y-0.5 hover:shadow-lg'
  const imageClassName = 'h-[42px] w-auto'
  const applePass =
    eventId && userEmail
      ? `https://liveonbeat.com/api/tickets/event/${eventId}/apple/${userEmail}`
      : ''
  const androidPass =
    eventId && userEmail
      ? `https://liveonbeat.com/api/tickets/event/${eventId}/android/${userEmail}`
      : ''

  const renderBadge = (href, src, alt) => {
    const image = <img src={src} alt={alt} className={imageClassName} />

    if (!href) {
      return (
        <span className={badgeClassName} aria-label={alt}>
          {image}
        </span>
      )
    }

    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={badgeClassName}
      >
        {image}
      </a>
    )
  }

  return (
    <div className="flex flex-col items-center gap-4 px-4 pb-7 pt-4 text-center text-white">
      <div className="max-w-2xl">
        <p className="text-lg font-semibold">{text}</p>
        <p className="mt-1 text-sm leading-relaxed">{subtext}</p>
        <p className="mt-1 text-xs leading-relaxed text-white/80">{note}</p>
      </div>
      <div className="flex flex-wrap items-center justify-center gap-4">
        {renderBadge(applePass, APPLE_WALLET_SVG, 'Add to Apple Wallet')}
        {renderBadge(
          androidPass,
          GOOGLE_WALLET_SVG,
          'Add to Google Wallet'
        )}
      </div>
    </div>
  )
}

export default Wallets